export default {
    SUCCESS: 1,
    FAILED: 2,
    UNCONFIRMED: 3,
};



// WEBPACK FOOTER //
// ./src/app/modules/trip/config/cancel-item-statuses.js